/**
 * Where the handle rests before an answer is chosen.
 * This is only a position on the track. It is not stored as the score.
 */
export function sliderRestValue(min: number, max: number): number {
    if (!Number.isFinite(min) || !Number.isFinite(max) || max < min) return Number.isFinite(min) ? min : 0;
    return Math.round((min + max) / 2);
}

/** A chosen slider answer. Missing or non-numeric values are unanswered. */
export function sliderCommittedValue(value: unknown): number | null {
    if (typeof value === "number" && Number.isFinite(value)) return value;
    return null;
}

/**
 * Text typed into the slider's number box.
 * An empty box clears the answer. A finite number commits it.
 * Incomplete text (a lone minus or decimal point) is ignored so the box can stay blank.
 */
export function parseSliderText(raw: string): number | null | undefined {
    const trimmed = raw.trim();
    if (trimmed === "") return null;
    if (trimmed === "-" || trimmed === "." || trimmed === "-.") return undefined;
    const next = Number(trimmed);
    if (!Number.isFinite(next)) return undefined;
    return next;
}
